import { useIsSmallScreen } from "@/utils/useIsSmallScreen"
import { Page } from "@components/Page"
import { PageLayoutGroup33_66 } from "@components/Page/PageLayoutGroup33_66"
import { ChatListForCurrentUser } from "@/routes/-components/chat/ChatListForCurrentUser"
import { SuspenseWithErrorBoundary } from "@components/suspense"

interface Props extends React.PropsWithChildren {
  renderLeftPanelOnSmallScreen?: boolean
}

export function ChatPage({
  children,
  renderLeftPanelOnSmallScreen = false,
}: Props) {
  const smallLayout = useIsSmallScreen()
  return (
    <Page
      scrollContainerProps={{ mt: smallLayout ? "xs" : "md" }}
      disableHeader
    >
      <SuspenseWithErrorBoundary>
        {smallLayout ? (
          renderLeftPanelOnSmallScreen ? (
            <ChatListForCurrentUser smallLayout={!!smallLayout} />
          ) : (
            children
          )
        ) : (
          <PageLayoutGroup33_66
            leftPanelContent={
              <ChatListForCurrentUser smallLayout={!!smallLayout} />
            }
            rightPanelContent={children}
          />
        )}
      </SuspenseWithErrorBoundary>
    </Page>
  )
}
